// The hub that holds a listing — 'SHUB' | 'VTHUB' | undefined — sent as originHub on
// add-reservation, scheduled/create and add-group-booking. VT-Backend books, approves
// and cancels on THIS hub, and needs it for G-/RU- ids, which exist on both hubs.
//
// Source of truth: the _source stamp the merged search and the deep-link load put on
// every listing ('SHUB'/'VTHUB'; the cluster flow carries 'sh'/'vt'). Unstamped, the id
// decides: 'sh…' ids live only on the Smiling House hub; G-/RU-/BP-/HW-/SM- ids go to the
// Villa Tracker hub — the hub makeCalculations quoted them on (it defaults to VTHUB when
// unstamped), so the booking follows the price the agent saw. Same rule as VT-Backend's
// hubClient.hubFromPropertyId. Any other id shape stays undefined (VT-Backend refuses
// the channel push loudly rather than guess).
export const normalizeOriginHub = (v) => {
  const s = String(v == null ? "" : v).trim().toUpperCase();
  if (s === "SHUB" || s === "SH") return "SHUB";
  if (s === "VTHUB" || s === "VT") return "VTHUB";
  return undefined;
};

const VTHUB_ID_PREFIX = /^(G|RU|BP|HW|SM)-/i;

export const originHubFromId = (id) => {
  const s = String(id || "").trim();
  if (s.toLowerCase().startsWith("sh")) return "SHUB";
  if (VTHUB_ID_PREFIX.test(s)) return "VTHUB";
  return undefined;
};

export const originHubOf = (listing) => {
  const stamped = normalizeOriginHub(listing?._source);
  if (stamped) return stamped;
  return originHubFromId(listing?._id || listing?.id);
};
